export const LOGIN_POPUP = 'LOGIN_POPUP';
export const LOCATION_POPUP = 'LOCATION_POPUP';
export const SEARCH_POPUP = 'SEARCH_POPUP';
export const ARTIST_POPUP = 'ARTIST_POPUP';
export const TICKET_POPUP = 'TICKET_POPUP';